import { render, staticRenderFns } from "./SiteDSP.vue?vue&type=template&id=0bdd3772&scoped=true"
import script from "./SiteDSP.vue?vue&type=script&lang=js"
export * from "./SiteDSP.vue?vue&type=script&lang=js"
import style0 from "./SiteDSP.vue?vue&type=style&index=0&id=0bdd3772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdd3772",
  null
  
)

export default component.exports